import { Component, OnInit, Input } from '@angular/core';
import { AbstractMenu } from '../menu.component';

@Component({
   selector: 'app-reseter',
   template: `
      <div class="defaults">
         <div class="reseters">
            <button (click)="menu.ctx.cols.reseter.all()" class="reseter all">Defaults</button>
            <div class="segregated">
               <button  *ngFor="let reseter of menu.ctx.cols.reseter.dataForDom" 
                        (click)="reseter.func()"
                        class="reseter">{{ reseter.title }}</button>
            </div>
         </div>
      </div>
   `,
   styleUrls: ['./reseter.component.scss']
})
export class ReseterComponent implements OnInit {
   @Input() public menu: AbstractMenu<any>;

   constructor() { }

   ngOnInit() {
   }

}
